/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Injectable } from '@angular/core';
import { ResourceInterface } from '@app/shared/models/resource.interface';
import { HttpClient } from '@angular/common/http';
import { ApiQuery } from '@app/core/http/api-query';
import { Observable } from 'rxjs';
import { PaginatedResponse } from '@app/shared/models/paginated-response.model';
import { HttpResponse } from '@app/core';
import { map } from 'rxjs/operators';
import { Type } from '@app/settings/types/types.model';
import { Model } from '@app/shared/models/model.model';

@Injectable({
  providedIn: 'root',
})
export class TypesService implements ResourceInterface {
  constructor(private http: HttpClient) {}

  index(query: ApiQuery = new ApiQuery()): Observable<PaginatedResponse> {
    return this.http
      .cache()
      .get('v1/types', query.buildGetOptions())
      .pipe(
        map((response: HttpResponse) => {
          response.data = response.data.map((type: any) => new Type().deserialize(type));
          return new PaginatedResponse().deserialize(response);
        })
      );
  }

  groups(query: ApiQuery = new ApiQuery()): Observable<PaginatedResponse> {
    return this.http
      .cache()
      .get('v1/types/groups', query.buildGetOptions())
      .pipe(
        map((response: HttpResponse) => {
          return new PaginatedResponse().deserialize(response);
        })
      );
  }

  update(type: Type): Observable<Type> {
    return this.http.put('v1/types/' + type.id, type).pipe(
      map((response: HttpResponse) => {
        return new Type().deserialize(response.data);
      })
    );
  }

  store(type: Type): Observable<Type> {
    return this.http
      .post('v1/types', type)
      .pipe(map((response: HttpResponse) => new Type().deserialize(response.data)));
  }

  show(id: number): Observable<Model> {
    return this.http
      .cache()
      .get('v1/types/' + id)
      .pipe(map((response: HttpResponse) => new Type().deserialize(response.data)));
  }

  destroy(id: number): Observable<any> {
    return this.http.delete('v1/types/' + id);
  }
}
